import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { LlmClient } from "../models/LlmClient";

export const useGetLlmClientDetails = () => {
  const {
    data: llmClientDetails,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<LlmClient>((response) => new LlmClient(response));

  const getLlmClientDetails = async (llmName: string, id: string) => {
    await call(`/admin/llm/${llmName}/clients/${id}`, "GET");
  };

  return {
    llmClientDetails,
    getLlmClientDetails,
    isLoading,
    isFailed,
  };
};
